import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function AutoCaptureSlotsPromptNode({ id, data }) {
    return (
        <NodeComponent title="Capture Slots" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

